/**
 * Rotation helpers (round 6). A print's `rotation` (0|90|180|270, clockwise) is
 * applied to the EXIF-corrected image BEFORE the crop — crop_rect is defined on
 * the ROTATED image, and DPI math uses the rotated pixel dimensions (width and
 * height swap at 90/270). Pure math, unit-tested in rotate.test.ts.
 */

/** Clockwise rotation applied to the EXIF-corrected image before crop. */
export type Rotation = 0 | 90 | 180 | 270;

export const ROTATIONS: readonly Rotation[] = [0, 90, 180, 270];

/** Coerce an arbitrary number (wire value) to a valid Rotation (default 0). */
export function asRotation(value: number | null | undefined): Rotation {
  return value === 90 || value === 180 || value === 270 ? value : 0;
}

/** The next 90° step clockwise. */
export function nextRotation(rotation: Rotation): Rotation {
  return (((rotation + 90) % 360) as Rotation);
}

/**
 * Pixel dimensions of the image AFTER rotation: width/height swap at 90/270.
 * All crop + DPI math downstream of a rotation runs on these dims.
 */
export function rotatedDims(width: number, height: number, rotation: Rotation): [number, number] {
  return rotation === 90 || rotation === 270 ? [height, width] : [width, height];
}
